import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Website from "./modules/website/index";
import Blog from "./modules/blog/index"; // Ensure correct path
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css"; // Import Font Awesome
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Login from "./modules/blog/components/Login";
import BlogManagement from "./modules/blog/components/BlogManagement";
import BlogForm from "./modules/blog/components/BlogForm";
import BlogPost from "./modules/blog/components/BlogPost/BlogPost";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
AOS.init();


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
      <Router>  
        
          <Routes>
          <Route path="/Login" element={<Login />} />
          <Route path="/blog/*" element={<Blog />} />
          <Route path="/blog/:id/*" element={<BlogPost />} />
          <Route path="/blog/admin" element={<BlogManagement />} />
          <Route path="/blog/new" element={<BlogForm />} />
          <Route path="/blog/edit/:id" element={<BlogForm />} />
          <Route path="/*" element={<Website />} />
        </Routes>
      </Router>
  </React.StrictMode>
);



